import './style.modules.scss'

import { BrandIcon, BrandIconColor } from '@ampcore/adel-react'
import { pascalCase } from '@ampcore/string-format'
import React from 'react'

import type { BrandIconCompoundProps } from './BrandIconCompound.type'

export const BrandIconCompound = (props: BrandIconCompoundProps) => {
  const {
    icon,
    iconColor,
    iconBgColor,
    fill,
    stroke,
    size,
    className,
    testId
  } = props

  if (iconBgColor) {
    const containerClassNames = [
      'BrandIconCompound',
      'BrandIconCompound--withBg',
      'u-padding20',
      'u-marginBottom20',
      `u-bgColor${pascalCase(iconBgColor)}`,
      className
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <div
        className={containerClassNames}
        data-testid={testId ? `${testId}-compound` : undefined}
      >
        <BrandIcon
          icon={icon}
          color={BrandIconColor.WHITE}
          fill
          className="BrandIconCompound-icon BrandIconCompound-icon--withBg"
          testId={testId}
        />
      </div>
    )
  }

  const iconClassNames = [
    'BrandIconCompound-icon',
    'BrandIconCompound-icon--default',
    'u-marginBottom20',
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <BrandIcon
      icon={icon}
      color={iconColor}
      fill={fill}
      stroke={stroke}
      size={size}
      className={iconClassNames}
      testId={testId}
    />
  )
}
